document.querySelectorAll('.js-video').forEach((wrap) => {
	const video = wrap.querySelector('video');
	const btn = wrap.querySelector('.js-play');

	// 再生ボタン
	btn.addEventListener('click', (e) => {
		e.stopPropagation();
		toggleVideo(video, wrap);
	});

	// 動画エリアクリック
	wrap.addEventListener('click', () => {
		toggleVideo(video, wrap);
	});

	// 再生終了時
	video.addEventListener('ended', () => {
		wrap.classList.remove('is-playing');
	});
});

// トグル関数
function toggleVideo(video, wrap) {
	if (video.paused) {
		video.play();
		wrap.classList.add('is-playing');
	} else {
		video.pause();
		wrap.classList.remove('is-playing');
	}
}